import { useEffect, useRef } from 'react';
import { SMS_DISCLOSURE_VERSION } from '@/utils/smsConsent';

const FORM_HTML = `
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.css">
<style>
.alf-lead-form-evolution-electric-lead-funnel{box-sizing:border-box;max-width:440px;margin:0 auto;padding:32px 28px 28px;background:#fff;border:2px solid #000;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#111827;}
.alf-lead-form-evolution-electric-lead-funnel *,.alf-lead-form-evolution-electric-lead-funnel *::before,.alf-lead-form-evolution-electric-lead-funnel *::after{box-sizing:inherit;}
.alf-lead-form-evolution-electric-lead-funnel .alf-title{margin:0 0 4px;font-size:22px;font-weight:800;letter-spacing:-0.02em;color:#000;text-transform:uppercase;}
.alf-lead-form-evolution-electric-lead-funnel .alf-sub{margin:0 0 22px;font-size:14px;line-height:1.5;color:#71717a;}
.alf-lead-form-evolution-electric-lead-funnel label{display:block;margin:0 0 14px;font-size:11px;font-weight:600;letter-spacing:0.1em;color:#52525b;text-transform:uppercase;}
.alf-lead-form-evolution-electric-lead-funnel input{display:block;width:100%;padding:12px 14px;margin-top:6px;background:#fafafa;border:1px solid #000;color:#111827;font:inherit;font-size:15px;font-weight:400;letter-spacing:normal;text-transform:none;-webkit-appearance:none;appearance:none;transition:border-color .15s,background .15s,box-shadow .15s;}
.alf-lead-form-evolution-electric-lead-funnel input::placeholder{color:#a1a1aa;}
.alf-lead-form-evolution-electric-lead-funnel input:hover{background:#fff;border-color:#52525b;}
.alf-lead-form-evolution-electric-lead-funnel input:focus{outline:none;background:#fff;border-color:#FACC15;box-shadow:0 0 0 3px rgba(250,204,21,0.25);}
.alf-lead-form-evolution-electric-lead-funnel .iti{display:block;width:100%;margin-top:6px;}
.alf-lead-form-evolution-electric-lead-funnel .iti input[type=tel]{margin-top:0;padding-left:96px;}
.alf-lead-form-evolution-electric-lead-funnel .iti__country-list{z-index:10000;font-family:inherit;font-size:14px;text-transform:none;letter-spacing:normal;color:#111827;}
.alf-lead-form-evolution-electric-lead-funnel .iti__country{padding:6px 10px;}
.alf-lead-form-evolution-electric-lead-funnel .iti__selected-flag{padding:0 8px 0 12px;}
.alf-lead-form-evolution-electric-lead-funnel button{margin-top:6px;padding:14px 20px;width:100%;background:#FACC15;color:#000;border:2px solid #000;font:inherit;font-size:14px;font-weight:800;letter-spacing:0.05em;text-transform:uppercase;cursor:pointer;transition:background .15s,transform .08s;}
.alf-lead-form-evolution-electric-lead-funnel button:hover{background:#eab308;transform:translateY(-2px);}
.alf-lead-form-evolution-electric-lead-funnel button:active{transform:translateY(1px);}
.alf-lead-form-evolution-electric-lead-funnel button:disabled{opacity:.6;cursor:not-allowed;transform:none;}
.alf-lead-form-evolution-electric-lead-funnel .alf-msg{margin-top:12px;min-height:18px;font-size:13px;line-height:1.5;color:#4b5563;text-align:center;}
.alf-lead-form-evolution-electric-lead-funnel .alf-msg.alf-ok{color:#059669;font-weight:600;}
.alf-lead-form-evolution-electric-lead-funnel .alf-msg.alf-err{color:#dc2626;}
.alf-lead-form-evolution-electric-lead-funnel .alf-consent{display:flex;align-items:flex-start;gap:10px;margin:4px 0 14px;font-size:11px;line-height:1.5;font-weight:400;letter-spacing:normal;text-transform:none;color:#52525b;cursor:pointer;}
.alf-lead-form-evolution-electric-lead-funnel .alf-consent input[type=checkbox]{display:inline-block;width:16px;height:16px;margin:2px 0 0;padding:0;flex-shrink:0;accent-color:#FACC15;border:1px solid #000;background:#fff;-webkit-appearance:checkbox;appearance:checkbox;}
.alf-lead-form-evolution-electric-lead-funnel .alf-consent a{color:#27272a;text-decoration:underline;}
.alf-lead-form-evolution-electric-lead-funnel .alf-consent strong{color:#27272a;font-weight:600;}
</style>
<form class="alf-lead-form-evolution-electric-lead-funnel" onsubmit="return alfSubmit_evolutionelectricleadfunnel(event)" novalidate>
  <h3 class="alf-title">Need Electrical Help?</h3>
  <p class="alf-sub">Tell us how to reach you and our electrical assistant will contact you shortly.</p>
  <label>Name <input name="name" type="text" placeholder="Jane Doe" required></label>
  <label>Email <input name="email" type="email" placeholder="jane@example.com" required></label>
  <label>Phone <input id="alfPhone_evolutionelectricleadfunnel" name="phone" type="tel" autocomplete="tel" placeholder="Phone number"></label>
  <label class="alf-consent" data-testid="agentic-sms-consent-label"><input type="checkbox" name="sms_consent" value="true" data-testid="agentic-sms-consent"><span><strong>Optional:</strong> By checking this box, I agree to receive text messages from Evolution Electric regarding my service inquiries, appointment confirmations, reminders, and follow-ups. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for assistance. Consent is not required to purchase services. See our <a href="/privacy-policy" data-testid="agentic-sms-consent-privacy-link">Privacy Policy</a> and <a href="/terms" data-testid="agentic-sms-consent-terms-link">Terms of Service</a>.</span></label>
  <button type="submit">Get Electrical Help</button>
  <div class="alf-msg" aria-live="polite"></div>
</form>
`;

const FORM_SCRIPT = `
(function(){
  var ITI_BASE='https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8';
  var phone=document.getElementById('alfPhone_evolutionelectricleadfunnel');
  if(!phone)return;
  function init(){
    if(phone.dataset.alfItiReady||!window.intlTelInput)return;
    try{
      var iti=window.intlTelInput(phone,{
        preferredCountries:['us','gb','ca','in','au'],
        separateDialCode:true,
        initialCountry:'auto',
        geoIpLookup:function(success){
          fetch('https://ipapi.co/json/').then(function(r){return r.json();})
            .then(function(j){success((j&&j.country_code)?j.country_code:'us');})
            .catch(function(){success('us');});
        },
        utilsScript:ITI_BASE+'/js/utils.js'
      });
      phone.dataset.alfItiReady='1';
      window['alfSubmit_evolutionelectricleadfunnel__iti']=iti;
    }catch(e){}
  }
  if(window.intlTelInput){init();return;}
  if(window.__alf_iti_loading){var t=setInterval(function(){if(window.intlTelInput){clearInterval(t);init();}},50);return;}
  window.__alf_iti_loading=true;
  var s=document.createElement('script');s.src=ITI_BASE+'/js/intlTelInput.min.js';s.async=true;
  s.onload=init;document.head.appendChild(s);
})();
window.alfSubmit_evolutionelectricleadfunnel=function(e){
  e.preventDefault();
  var f=e.target,btn=f.querySelector('button[type=submit]'),msg=f.querySelector('.alf-msg'),fd=new FormData(f);
  var consentBox=f.querySelector('input[name=sms_consent]');
  var smsConsent=!!(consentBox&&consentBox.checked);
  var DISCLOSURE_VERSION='${SMS_DISCLOSURE_VERSION}';
  var SOURCE='homepage-need-electrical-help';
  var API=(window.__REACT_APP_BACKEND_URL||'')+'/api';
  var iti=window['alfSubmit_evolutionelectricleadfunnel__iti'];
  var dial='';
  if(iti && iti.getSelectedCountryData){
    dial=(iti.getSelectedCountryData().dialCode)||'';
    if(dial)fd.append('select_country',dial);
  }
  fd.delete('sms_consent');
  fd.append('sms_consent',smsConsent?'true':'false');
  fd.append('sms_consent_source',SOURCE);
  fd.append('sms_disclosure_version',DISCLOSURE_VERSION);
  if(smsConsent){fd.append('sms_consent_timestamp',new Date().toISOString());}
  fd.append('source','html_form');
  fd.append('user_timezone',Intl.DateTimeFormat().resolvedOptions().timeZone||'');
  fd.append('url',location.href);
  msg.className='alf-msg';msg.textContent='Submitting\\u2026';
  if(btn){btn.disabled=true;}
  if(!smsConsent){
    // No SMS consent: keep the lead OUT of the SMS-enabled Agentic funnel.
    // Capture it on our own backend for owner notification + manual follow-up.
    var rawPhone=fd.get('phone')||'';
    var leadPayload={name:fd.get('name')||'',email:fd.get('email')||'',phone:(dial&&rawPhone&&rawPhone.indexOf('+')!==0?('+'+dial+' '):'')+rawPhone,
      service:'Need Electrical Help? (no SMS consent — manual follow-up)',message:'Submitted via homepage "Need Electrical Help?" form without SMS consent. Do not enroll in automated texting; follow up by phone or email.',
      source:'homepage-need-electrical-help-no-sms-consent',sms_consent:false,sms_consent_source:SOURCE,sms_consent_page_url:location.href,sms_disclosure_version:DISCLOSURE_VERSION};
    fetch(API+'/leads',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(leadPayload),mode:'cors'})
      .then(function(r){if(!r.ok)throw new Error('lead');return r.json();})
      .then(function(){msg.className='alf-msg alf-ok';msg.textContent="Thanks! We\\u2019ll contact you shortly.";f.reset();})
      .catch(function(){msg.className='alf-msg alf-err';msg.textContent='Something went wrong. Please call (615) 961-5930.';})
      .then(function(){if(btn){btn.disabled=false;}});
    return false;
  }
  fetch('https://agenticagencyapp.com/widget/submit/evolution-electric-lead-funnel',{method:'POST',body:fd,mode:'cors'})
    .then(function(r){return r.json();}).then(function(j){
      var isNew=j&&j.status==1;
      var isDupe=j&&j.status==11;
      var ok=isNew||isDupe;
      msg.className='alf-msg '+(ok?'alf-ok':'alf-err');
      if(isNew){msg.textContent="Thanks! We\\u2019ll contact you shortly.";}
      else if(isDupe){msg.textContent="You\\u2019re already in our system. We\\u2019ll be in touch shortly.";}
      else{msg.textContent=(j&&j.message)||'Something went wrong.';}
      if(ok){
        var notifyData={name:fd.get('name')||'',email:fd.get('email')||'',phone:fd.get('phone')||'',page_url:fd.get('url')||location.href,timezone:fd.get('user_timezone')||'',agentic_status:isNew?1:11,
          sms_consent:true,sms_consent_source:SOURCE,sms_disclosure_version:DISCLOSURE_VERSION};
        try{fetch(API+'/notify/agentic-lead',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(notifyData),mode:'cors'});}catch(ex){}
        f.reset();
      }
    }).catch(function(){msg.className='alf-msg alf-err';msg.textContent='Network error.';})
    .then(function(){if(btn){btn.disabled=false;}});
  return false;
};
`;

export default function AgenticLeadForm() {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    // Make backend URL available to the vanilla JS form script
    window.__REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
    // Inject the exact original HTML
    containerRef.current.innerHTML = FORM_HTML;
    // Execute the original script
    const script = document.createElement('script');
    script.textContent = FORM_SCRIPT;
    containerRef.current.appendChild(script);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="agentic-lead-form"
      style={{ maxWidth: '480px', width: '100%' }}
    />
  );
}
